// product swiper mobile only (for the search dropdown menu)
$(document).ready(function () {
  var breakpoint = window.matchMedia('(min-width:990px)');
  var mySwiper;

  var breakpointChecker = function () {
    if (breakpoint.matches === true) {
      if (mySwiper !== undefined) mySwiper.destroy(true, true);
      return;
    } else if (breakpoint.matches === false) {
      return enableSwiper();
    }
  };

  var enableSwiper = function () {
    mySwiper = new Swiper('[data-products-swiper-mobile]', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      slidesOffsetBefore: 12,
      observer: true,
    });
  };
  breakpoint.addListener(breakpointChecker);
  breakpointChecker();
});

// product swiper
$(document).ready(function () {
  function initSwiper() {
    var slidesPerView = 4;
    var loop = true;

    if ($('[data-products-swiper]').data('swiperSlidesPerView')) {
      slidesPerView = $('[data-products-swiper]').data('swiperSlidesPerView');
    }

    if (
      $('[data-products-swiper]').data('swiperNoLoop') ||
      $('[data-products-swiper]').data('swiperNoLoop') == ''
    ) {
      loop = false;
    }

    var mySwiper = new Swiper('[data-products-swiper]', {
      loop: loop,
      navigation: {
        nextEl: '[data-products-swiper-next]',
      },
      slidesPerView: 'auto',
      spaceBetween: 12,
      slidesOffsetBefore: 12,
      slidesOffsetAfter: 12,
      breakpoints: {
        0: {
          slidesOffsetBefore: 0,
          slidesPerView: 'auto',
          slidesOffsetAfter: 0,
        },
        500: {
          slidesOffsetBefore: 0,
          slidesPerView: 2,
          slidesOffsetAfter: 0,
        },
        990: {
          slidesOffsetBefore: 0,
          slidesPerView: slidesPerView,
          slidesOffsetAfter: 0,
        },
      },
    });
  }

  initSwiper();

  // this event is triggered on product recommenations ajax call in theme.js
  $(document).on('productSwiperInit', function () {
    initSwiper();
  });
});
